<template>
    <div>
        <h5>Attribute Designer</h5>
        <hr />
        <TabView v-if="currentAttribute" v-model:activeIndex="active">
            <TabPanel header="General">
                <div class="field">
                    <label for="code">Code</label>
                    <div class="p-inputgroup">
                        <InputText maxlength = "255" :placeholder="currentAttribute.code" disabled="true" />
                    </div>
                </div>
                <div v-if="![1, 2, 3].includes(parseInt(currentAttribute.type))" class="field">
                    <label for="label">Field Label</label>
                    <div class="p-inputgroup">
                        <InputText maxlength = "255" :placeholder="currentAttribute.label" disabled="true" />
                    </div>
                </div>
                <div v-if="[4, 5, 6, 8, 9].includes(parseInt(currentAttribute.type))" class="field">
                    <label for="placeholder">Placeholder</label>
                    <div class="p-inputgroup">
                        <InputText maxlength = "255" :placeholder="currentAttribute.placeholder" disabled="true" />
                    </div>
                </div>
                <div class="field">
                    <label for="icon">Icon</label>
                    <div class="p-inputgroup">
                        <i v-if="currentAttribute.icon" :class="['pi', currentAttribute.icon]"></i>
                        <span v-else>No Icon</span>
                    </div>
                </div>
                <div class="field">
                    <label for="version">Version</label>
                    <div class="p-inputgroup">
                        <!-- <InputText :placeholder="currentAttribute.version" disabled="true" /> -->
                        {{ currentAttribute.version }}
                    </div>
                </div>
                <div class="field">
                    <label for="required">Field Required</label>
                    <div class="p-inputgroup">
                        <InputSwitch v-model="currentAttribute.required" disabled="true" />
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Options" :disabled="currentAttribute.options && currentAttribute.options.length > 0 ? false : true">
                <div class="grid">
                    <div class="field col-6">
                        <label for="placeholder">Options</label>
                        <div class="p-inputgroup">
                            <Textarea class="text-area-lines" :modelValue="currentAttribute.options?.map((item) => item.label).join('\n')" rows="5" cols="30" readOnly />
                        </div>
                    </div>
                    <div class="field col-6">
                        <label for="placeholder">Values</label>
                        <div class="p-inputgroup">
                            <Textarea class="text-area-lines" :modelValue="currentAttribute.options?.map((item) => item.value).join('\n')" rows="5" cols="30" readOnly />
                        </div>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Advanced" :disabled="currentAttribute.tags && currentAttribute.tags.length > 0 ? false : true">
                <div class="field">
                    <label for="tags">Tags</label>
                    <div class="p-inputgroup">
                        <span v-for="item in currentAttribute.tags" :key="item">
                            <Chip :label="item?.tag?.code" class="mr-2 mb-2 custom-chip"></Chip>
                        </span>
                    </div>
                </div>
                <!--This may be used later in future versions so its commented for now 
                    <div :style="{ 'overflow-y': auto, height: '48vh' }">
                    <h5>Condition</h5>
                    <h6>If the Attribute Value is:</h6>
                    <div class="field">
                        <label for="operator">Operator</label>
                        <div class="p-inputgroup">
                            <Dropdown :options="operators" optionLabel="name" placeholder="Choose Operator" />
                        </div>
                    </div>
                    <div class="field">
                        <label for="criteria">To Criteria Value</label>
                        <div class="p-inputgroup">
                            <InputText />
                        </div>
                    </div>
                    <div class="field">
                        <label for="impactedAttributes">Then following Attributes are Impacted:</label>
                        <div class="p-inputgroup">
                            <MultiSelect placeholder="Select the impacted attributes" :options="updatedFormItems" />
                        </div>
                    </div>
                    <div class="field">
                        <label for="attribute">{{ switchValue ? 'Show' : 'Hidden' }}</label>
                        <div class="p-inputgroup">
                            <InputSwitch v-model="switchValue" />
                        </div>
                    </div>
                </div> -->
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
export default {
    name: 'FormDesigner',
    props: {
        activeAttribute: {
            type: Object,
        },
        updatedFormItems: {
            type: Object,
        },
    },
    watch: {
        activeAttribute: {
            immediate: true,
            handler() {
                this.active = 0;
                this.currentAttribute = this.activeAttribute;
            },
        },
    },
    data() {
        return {
            active: 0,
            currentAttribute: null,
            operators: null,
        };
    },
};
</script>

<style lang="scss" scoped>
label {
    font-weight: 600;
}
.text-area-lines::before {
    content: '';
    display: block;
    position: relative;
    top: -1.5em;
    height: 1px;
    background-color: black;
}
.chip-display {
    overflow-y: auto;
}

::v-deep(.custom-chip) {
    border-radius: 4px;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
}
</style>
